<div class="tab-content">
    <form #form="ngForm" class="form container-fluid pl-0 pr-0">
        <div class="hero-text" style="margin-left: 10px;">
            <h1 style="font-weight: 800;">{{'REGION'|translate}} {{'UPDATE'|translate}}</h1>
        </div>
        <mat-form-field appearance="outline" floatLabel="always" class="w-100-p">
            <mat-label>{{'TITLE'|translate}}</mat-label>
            <input matInput placeholder="{{'TITLE'|translate}}" name="name" [(ngModel)]="model.name" required>
        </mat-form-field>
        <mat-form-field appearance="outline" floatLabel="always" class="w-100-p">
            <mat-label>{{'CONTAINER_COLLECTION_THRESHOLD'|translate}}</mat-label>
            <input matInput placeholder="{{'CONTAINER_COLLECTION_THRESHOLD'|translate}}" name="treshold" [(ngModel)]="model.treshold" required>
        </mat-form-field>

        <button mat-raised-button (click)="save()">
            <span>{{'CREATE'|translate}}</span>
        </button>
    </form>
</div>